<template>
  <v-container :class="color" fluid class="pb-0">
    <v-row>
      <v-card flat color="transparent" class="mx-auto py-6 text-center" >
        <v-row justify="center" class="ma-0 pa-0">
          <v-card-title class="display-1 text-center">{{ title }}</v-card-title>
        </v-row>
        <v-card-subtitle class="subtitle-1 text-center ma-0 pa-0">{{ subtitle }}</v-card-subtitle>
      </v-card>
    </v-row>
    <slot></slot>
  </v-container>
</template>

<script>
export default {
    name: 'TciTitle',
    props: {
      title: String,
      subtitle: String,
      color: String,
    }
}
</script>
